/**
 * ManageCampaignHeader
 *
 * Header for the campaigns management view with edit toggle and create button;
 * disables actions when user has read-only permission.
 */
import React from 'react';
import { Pencil, Plus, Shield, Crown } from 'lucide-react';

export default function ManageCampaignHeader({ 
  isEditMode, 
  onToggleEdit, 
  onNewCampaign,
  hasCampaigns,
  currentNamespace,
  userPermission,
  hasReadOnlyPermission
}) {
  // Check if user can create/edit campaigns
  const canCreateOrEdit = !hasReadOnlyPermission;
  
  return (
    <div className="mb-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="flex items-center gap-2">
            <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
              Manage Campaigns
            </h1>
          </div>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            Create and manage your marketing campaigns in one place.
          </p>
        </div>
        <div className="mt-4 flex items-center gap-3 sm:mt-0">
          {hasCampaigns && canCreateOrEdit && (
            <button
              onClick={onToggleEdit}
              className="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
            >
              <Pencil className="h-4 w-4" />
              {isEditMode ? 'Done Editing' : 'Edit Campaigns'}
            </button>
          )}
          <button
            onClick={canCreateOrEdit ? onNewCampaign : undefined}
            className={`inline-flex items-center gap-1.5 rounded-lg px-4 py-2.5 text-sm font-medium text-white transition-all duration-200 ${
              canCreateOrEdit 
                ? 'bg-primary-600 hover:bg-primary-700 hover:scale-105 dark:bg-primary-600 dark:hover:bg-primary-700' 
                : 'bg-primary-400 dark:bg-primary-800 cursor-not-allowed'
            }`}
            title={canCreateOrEdit ? "Create a new campaign" : "You need edit permissions to create campaigns"}
          >
            {canCreateOrEdit ? <Plus className="h-4 w-4" /> : <Shield className="h-4 w-4" />}
            New Campaign
          </button>
        </div>
      </div>
    </div>
  );
}